import { Component, OnInit, OnDestroy } from '@angular/core';
import { interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface Advertisement {
  image: string;
  alt: string;
}

@Component({
  selector: 'app-advertisement-carousel',
  templateUrl: './advertisement-carousel.component.html',
  styleUrls: ['./advertisement-carousel.component.css']
})
export class AdvertisementCarouselComponent implements OnInit, OnDestroy {
  advertisements: Advertisement[] = [
    {
      image: 'assets/images/publicidad/gabrica-publi-1.jpeg',
      alt: 'Publicidad Gabrica 1'
    },
    {
      image: 'assets/images/publicidad/gabrica-publi-2.jpeg',
      alt: 'Publicidad Gabrica 2'
    },
    {
      image: 'assets/images/publicidad/gabrica-publi-3.jpeg',
      alt: 'Publicidad Gabrica 3'
    },
    {
      image: 'assets/images/publicidad/gabrica-publi-4.jpeg',
      alt: 'Publicidad Gabrica 4'
    }
  ];

  currentIndex: number = 0;
  private destroy$ = new Subject<void>();

  constructor() { }

  ngOnInit(): void {
    this.startCarousel();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private startCarousel(): void {
    interval(6000) // 6 segundos
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.nextAd();
      });
  }

  nextAd(): void {
    this.currentIndex = (this.currentIndex + 1) % this.advertisements.length;
  }

  prevAd(): void {
    this.currentIndex = (this.currentIndex - 1 + this.advertisements.length) % this.advertisements.length;
  }

  goToAd(index: number): void {
    this.currentIndex = index;
  }
}